module.exports = {
  siteUrl: 'https://www.bolleneaventure.com',
  sitemapPath: '/sitemap.xml',
  title: 'Bollène Aventure',
  description: "Parc aventure",
  author: '@oliviergenevest',
  locales: {fr:
    {
      path: 'fr',
      name: 'Français',
      default: true
    },
/*    en:
    {
      path: 'en',
      name: 'English'
    }*/
  },

};
